export const LoiTermFormFieldKeys = {
    loiExpirationDate: 'loiExpirationDate',
    exclusivityPeriodMonth: 'exclusivityPeriodMonth',

    practicePropertyPurchased: 'practicePropertyPurchased',
    practiceRealPropertyInclude: 'practiceRealPropertyInclude',

    cashAtClose: 'cashAtClose',
    workingCapitalHoldback: 'workingCapitalHoldback',
    netCashAtClose: 'netCashAtClose',
    earnout: 'earnout',
    syntheticJvEquity: 'syntheticJvEquity',
    deferredFixedPaymentsTotal: 'deferredFixedPaymentsTotal',
    deferredVariablePaymentsTotal: 'deferredVariablePaymentsTotal',
    jvEquityTotal: 'jvEquityTotal',
    corporateEquityTotal: 'corporateEquityTotal',
    other: 'other',
    totalPurchasePrice: 'totalPurchasePrice',

    paymentObligor: 'paymentObligor',
    assetsHeldByObligor: 'assetsHeldByObligor',
    interestAppliedToDeferredPayments: 'interestAppliedToDeferredPayments',
} as const;

export const LoiTermFormRowFieldKey = {
    dfpRow: (index: number) => `dfp:${index}`,
    dvpRow: (index: number) => `dvp:${index}`,
    jvEquityRow: (index: number) => `jvEquity:${index}`,
    corporateEquityRow: (index: number) => `corporateEquity:${index}`,
    leaseRow: (locationId: string) => `lease:${locationId}`,
    ncrRow: (index: number) => `ncr:${index}`,
    amcRow: (index: number) => `amc:${index}`,
};
